var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "card",
    class: _vm.$style.container
  }, [_vm._m(0), _vm._m(1), _c('a-form', {
    staticClass: "mb-4",
    attrs: {
      "form": _vm.form
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['password', {
        rules: [{
          required: true,
          message: 'Unesite vašu lozinku!'
        }]
      }],
      expression: "['password', {rules: [{ required: true, message: 'Unesite vašu lozinku!' }]}]"
    }],
    attrs: {
      "size": "large",
      "placeholder": "Lozinka"
    }
  })], 1), _c('a-button', {
    staticClass: "text-center w-100",
    attrs: {
      "type": "primary",
      "size": "large"
    }
  }, [_c('strong', [_vm._v("Otključaj nalog")])])], 1)], 1), _c('div', {
    staticClass: "text-center pt-2 mb-auto"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v("Već imate nalog?")]), _c('router-link', {
    staticClass: "kit__utils__link font-size-16",
    attrs: {
      "to": "/auth/login"
    }
  }, [_vm._v("Prijavljivanje")])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-dark text-center font-size-24 mb-4"
  }, [_c('strong', [_vm._v("Nalog je zaključan")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "kit__utils__avatar kit__utils__avatar--size64 d-inline-block mb-2"
  }, [_c('img', {
    attrs: {
      "src": "resources/images/avatars/2.jpg",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "font-size-18 text-dark mb-4"
  }, [_c('strong')])]);
}]

export { render, staticRenderFns }